<template>
  <div id="home" class="maincont">
    <div class="multi-circuit-ef--inner graph-container">

      <!-- グラフヘッダ -->
      <div class="graph-header">
        <h2 class="graph-header-caption">電力需給状況</h2>
        <ul class="graph-header-button graph-header-button-item">
          <li id="iAuto-update" class="graph-header-button-item auto-update-tooltip">
            <button @click="toggleAutoUpdate" id="auto-update-btn" class="bt-enable">自動更新</button>
            <div class="auto-update-tooltip-description" id="auto-update-tooltip-description">現在、自動更新有効です。</div>
          </li>
          <li class="graph-header-button-item">
            <button id="iCSVDownloadBtn" href="javascript:void(0);" class="bt-csv-gray" @click="onExportCSV" >CSVダウンロード</button>
          </li>
        </ul>
      </div>

      <!-- グラフコンテンツ -->
      <div class="graph-content">

        <!-- 期間選択 -->
        <div class="graph-control graph-control-item">
          <div class="margin0auto">
            <span class="select-box">
              <select id="select-period" name="select-period" v-model="selectInterval">
                <option value="1" selected="selected">直近30分</option>
                <option value="2">日別</option>
                <option value="3">月別</option>
              </select>
            </span>
          </div>
        </div>

        <!-- カレンダー -->
        <div id="iCal" class="display-period" style="visibility:hidden;">
          <span class="select-date">
            <button @click="ctrlDate(0)" class="bt-date">&lt;</button>
            <input :type="periodInputType" v-model="periodStartDate" v-on:change="selectPeriod('-1')">
            <button @click="ctrlDate(1)" class="bt-date">&gt;</button>
          </span>
        <div class="rc-week">
          <p id="iCalWeek"></p>
        </div>
        </div>
        <!-- グラフ -->
        <div class="graph">
          <p class="text-align-center" v-if="!isExist">データが存在しません</p>
          <canvas id="canvas" height="80%"></canvas>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Chart from "chart.js";
import Store from "../../store";
import Utils from "../../utils/utils";

export default {
  name: "shop_aggregation",
  components: {
  },
  data: function() {
    return {
      selectInterval: "1",
      autoUpdateTime: 60000,
      autoUpdateId: null,	//日別グラフと月別グラフは、常時1分更新、直近30分グラフは初期：常時1分更新、ボタン操作でOFFにする。
      autoUpdateStatus: 1,	//0:自動更新無効 1:自動更新有効(グラフが日別・月別から直近30分に切り替わった時にグラフ更新タイマーを停止するかの判定に使用)
      periodJpList: [
        "直近30分",
        "日別",
        "月別",
      ],
      periodInputType: "datetime-local",
      periodStartDate: "",
      periodEndDate: "",
      graphData: [],
      graphLabel: [],
      graphSettings: {	/* グラフ設定 */
        graphColorList: [	// グラフカラー
          'rgba(86, 161, 229, 1)' ,'rgba(255, 140, 0, 1)'  , 'rgba(160, 160, 160, 1)',
          'rgba(255, 240, 150, 1)', 'rgba(0, 120, 190, 1)'  , 'rgba(70, 180, 30, 1)'  ,
          'rgba(99,57,187, 1)'  , 'rgba(25,197,215, 1)' ,  'rgba(167,91,79, 1)'  , 
          'rgba(207,155,35, 1)' , 'rgba(126,198,171, 1)', 'rgba(58,91,97, 1)'   ,
          'rgba(30,31,57, 1)'   , 'rgba(102,110,163, 1)', 'rgba(255, 0, 0, 1)'    ,
          'rgba(64,182,116, 1)' , 'rgba(25,207,10, 1)'  ,'rgba(177,7,125, 1)'  ,
          'rgba(255,56,18, 1)'  , 'rgba(100,149,31, 1)' , 'rgba(100, 210, 60, 1)' ,
          'rgba(29,104,160, 1)' , 'rgba(68,82,145, 1)'  , 'rgba(109, 190, 191, 1)',
          'rgba(44,247,190, 1)' , 'rgba(186,251,25, 1)' , 'rgba(242, 163, 84, 1)' ,
          'rgba(125,76,43, 1)'  , 'rgba(59,43,251, 1)'  , 'rgba(145, 107, 246, 1)',
          'rgba(52,182,5, 1)'   , 'rgba(35,74,17, 1)'   , 'rgba(232,183,200, 1)'  ,
          'rgba(25,112,102, 1)' , 'rgba(219,54,103, 1)' , 'rgba(4,211,154, 1)'    ,
          'rgba(241,248,40, 1)' , 'rgba(213,194,188, 1)', 'rgba(39,152,38, 1)'    ,
          'rgba(218,198,168, 1)', 'rgba(13,74,57, 1)'   , 'rgba(5,12,230, 1)'     ,
          'rgba(9,84,168, 1)'   , 'rgba(60,211,243, 1)' , 'rgba(90,227,97, 1)'    ,
          'rgba(176,130,132, 1)', 'rgba(40,2,40, 1)'    , 'rgba(161,213,163, 1)'  ,
          'rgba(170,209,113, 1)', 'rgba(0,23,32, 1)'
        ],

        backgroundColorForLine: 'rgba(255, 255, 255, 0)',	// グラフカラー 折れ線用
        backgroundColorForForecast: 'rgba(230, 230, 230, 1)',	// グラフカラー 合成需給予測値用

        borderColorForTotal: 'rgba(255, 0, 0, 1)',	// グラフボーダーカラー 合成需給用
        borderColorForAverage: 'rgba(0, 0, 0, 1)'	// グラフボーダーカラー 合成需給平均値用
      },
      graphOptions: {
          // 描画アニメーション
          animation: false,
          
          // ツールチップ設定
          tooltips: {
            // まとめて表示
            mode: 'index',
            // 表示文字のカスタマイズ
            callbacks: {
              // タイトル
              title: (tooltipItem, data) => {
                const tooltipTitleTxt = "過去５分間のデータを示す\n当日";
                const xLabel = tooltipItem[0].xLabel;
                const title = tooltipTitleTxt + (((""+xLabel).length<2)? "0"+xLabel : xLabel);
                return title;
              },
              // ラベル
              label: (tooltipItem, data) => {
                const { label } = data.datasets[tooltipItem.datasetIndex];
                const value = tooltipItem.value.replace('NaN', 'データが存在しません');
                return value && `${label}: ${value}`;
              },
            }
          },
          // ラベル設定
          legend: {
            // グラフの下に表示
            position: "bottom",
            labels: {
              // アイコンの幅
              boxWidth: 12,
            },
          },

          datasets: {
            line: {
              tension: 0.4
            },
            bar: {
              categoryPercentage: 0.8,
              barPercentage: 0.5,
            },
          },

          scales: {
            // X軸設定
            xAxes: [{
              //// 目盛りに対する幅
              //categoryPercentage: 0.8,	// ここでの宣言は非推奨なので移動 bar chart: "scales.[x/y]Axes.categoryPercentage" is deprecated. Please use "dataset.categoryPercentage" instead
              //// categoryPercentageに対する幅
              //barPercentage: 0.5,
              ticks: {
                // 横幅が狭くなったときの表示の間引き
                autoskip: false,
              },
              gridLines: {
                // 目盛り線の表示
                display: false,
              },
            },],
            // Y軸設定
            yAxes: [
              {
                id: "y-axis-1",
                type: "linear",
                position: "left",
                ticks: {
                  callback: function (value, index,) {
                    if (index === 0) {
                      const rt = this.yAxesTicksTxt;
                      return rt;
                    }
                    return value.toFixed(1);
                  },
                },
              }]
          }
      },
      isExist: null,
      reqErrorFlg: 0,	// 0:エラーなし、1:エラーあり
      isBeforeDestoryFlg:false,
    };
  },

  watch: {
    selectInterval: function(newValue, oldValue) {
      
      //表示制御
      const calenderStyle=document.getElementById("iCal").style;	// カレンダー
      const btnAutoUpdateStyle=document.getElementById("iAuto-update").style;	// 自動更新ボタン
      
      if(newValue == "2"){	//日別
        btnAutoUpdateStyle.visibility="hidden";

        this.periodInputType="date";
        document.getElementById("iCalWeek").textContent = "（"+this.getDateWeekTxt(this.periodStartDate)+"）";
        calenderStyle.visibility="visible";
      }
      else if(newValue == "3"){	//月別
        btnAutoUpdateStyle.visibility="hidden";

        this.periodInputType="month";
        document.getElementById("iCalWeek").textContent = "";
        calenderStyle.visibility="visible";
      }
      else{	//直近30分
        btnAutoUpdateStyle.visibility="visible";

        this.periodInputType="datetime-local";
        document.getElementById("iCalWeek").textContent = "";
        calenderStyle.visibility="hidden";
      }
      this.periodStartDate = this.generationDateStr(new Date());	//カレンダーの日付を指定
      //グラフ制御
      this.setGraph(this.periodStartDate);	//グラフデータ取得・表示
      
    },
  },

  created: function() {
    this.periodStartDate = this.generationDateStr(new Date());	//カレンダーの日付を指定
  },

  // DOM生成後の初期処理
  mounted: function () {
    //グラフ制御
    this.setGraph(this.periodStartDate);
  },

  // この画面部品の破棄直前処理
  beforeDestroy: function() {
// console.log("■■■■■■beforeDestroy：グラフ更新タイマー停止 タイマーID="+this.autoUpdateId);
    if(this.autoUpdateId != null){	//グラフ更新タイマー初期化
      clearInterval(this.autoUpdateId);
    }
    this.isBeforeDestoryFlg = true;
  },

  methods: {

    // 横軸（月別用：年月に応じた日リストを返却）
    getXAxisMonthdays: function(pVal) {
      let rtAry= [];
      let pValAry=String(pVal).split("-");
      if(pValAry.length > 0){
        let YYYY = pValAry[0];
        let MM = 0;	//初期値：1月
        let DD = 1;	//初期値：1日
        if(pValAry.length > 1){
          let wkMM = Number(pValAry[1]) - 1;
          if(wkMM > -1) MM = wkMM;
        }
        if(pValAry.length > 2){
          DD = Number(pValAry[2])
        }
        
        //例えば2月の日数を知るには、3月のDateオブジェクトから前月最終日を取得する。
        let lastDate = new Date(YYYY,(MM+1),0);
        // Dateの第二引数は0始まり(0, 1, 2...が1月, 2月, 3月...)
        // Dateの第三引数に0を入れると前月の最終日になる。
        
        //該当月の日数取得
        let dayCnt = lastDate.getDate();
        for(let dayVal=1;rtAry.length < dayCnt;dayVal++){
          rtAry[rtAry.length]= dayVal;
        }
      }
      return rtAry;
    },

    /* 横軸（直近30分用） */
    getXAxisMinutes: function(pStartDateTimeStr) {
      let XInterval = 5;	//軸間隔5分毎
      const Xcount = 30 / XInterval;

      let rtAry = [];
      let wkDate=new Date(pStartDateTimeStr);
      //表示開始時刻はサーバーから受け取った時刻からXIntervalぶん進める。
      for(let i=0;i<Xcount;i++){
        wkDate.setMinutes( wkDate.getMinutes() + XInterval);
        let HH=((""+wkDate.getHours()).length < 2)? "0"+wkDate.getHours() : wkDate.getHours();
        let DD=((""+wkDate.getMinutes()).length < 2)? "0"+wkDate.getMinutes() : wkDate.getMinutes();
        rtAry[rtAry.length]=HH + ":" + DD;
      }
      
      return rtAry;
    },

    /* グラフ描画 */
    drawGraph: function(data, target) {
      // アカウント毎のグラフリスト
      let graphDataList = [];

      // カラーカウント
      let colorCount = 0;
      
      if (this.selectInterval == "1") {	// 直近30分のみ
        // 合成需給予測値のグラフ情報
        // 単位期間毎の合成需給予測値リスト
        let valueListForForecast = [];

        // 単位期間ごとに行う
        for (let i = 0; i < this.graphLabel.length; i++) {
          let value = data.total_forecast_list[i].value;
          valueListForForecast.push(value);
        }

        let forecastGraphData = {
          label: "予測値",
          data: valueListForForecast,
          stack: "bar",
          backgroundColor: this.graphSettings.backgroundColorForForecast,

        };
        graphDataList.push(forecastGraphData);
      }
      
      // 消費電力または消費電力量
      // アカウントごとに行う
      for (let i = 0; i < data.demand_list_by_account.length; i++) {

        // アカウントごとの全期間の値リスト
        let valueListForDemand = [];

        // 単位期間ごとに行う
        for (let j = 0; j < this.graphLabel.length; j++) {
        
          // 単位期間ごとの値
          let value = data.demand_list_by_account[i].data_list[j].value;
        
          // 消費電力表示用
          valueListForDemand.push(value);
        }

//        console.log(data.demand_list_by_account[i].company_name);
//        console.log(valueListForDemand);

        if(colorCount >= this.graphSettings.graphColorList.length) colorCount = 0;

        // アカウントのグラフ情報
        let demandGraphData = {
          label: data.demand_list_by_account[i].company_name,
          stack: "bar",
          data: valueListForDemand,
          backgroundColor: this.graphSettings.graphColorList[colorCount++]
        };
        graphDataList.push(demandGraphData);
      }

      //  発電電力または発電電力量
      // アカウントごとに行う
      for (let i = 0; i < data.generation_list_by_account.length; i++) {

        // アカウントごとの全期間の値リスト
        let valueListForGeneration = [];
        if (data.generation_list_by_account[i].data_list == null) {
          continue;
        }

        // 単位期間ごとに行う
        for (let j = 0; j < this.graphLabel.length; j++) {
        
          // 単位期間ごとの値 発電はマイナス方向に表示させる
          let value = null;
          if(data.generation_list_by_account[i].data_list[j].value != null) value = data.generation_list_by_account[i].data_list[j].value * (-1);	// null*(-1)の結果は0になるので、null判定をする。

          // 発電電力表示用
          valueListForGeneration.push(value);
        }

        if(colorCount >= this.graphSettings.graphColorList.length) colorCount = 0;
        
        // アカウントのグラフ情報
        let generationGraphData = {
          label: data.generation_list_by_account[i].company_name,
          data: valueListForGeneration,
          stack: "bar",
          backgroundColor: this.graphSettings.graphColorList[colorCount++],
        };
        graphDataList.push(generationGraphData);
      }

      // 蓄電残量
      if (this.selectInterval != "1") {	// 月別、日別のみ
        // アカウントごとに行う
        for (let i = 0; i < data.storage_list_by_account.length; i++) {

          // アカウントごとの全期間の値リスト
          let valueListForStorage = [];

          if (data.storage_list_by_account[i].data_list == null) {
            continue;
          }

          // 単位期間ごとに行う
          for (let j = 0; j < this.graphLabel.length; j++) {

            // 単位期間ごとの値
            let value = data.storage_list_by_account[i].data_list[j].value;

            // 蓄電残量表示用
            valueListForStorage.push(value);
            
          }
          
          if(colorCount >= this.graphSettings.graphColorList.length) colorCount = 0;
        
          // アカウントのグラフ情報
          let storageGraphData = {
            label: data.storage_list_by_account[i].company_name,
            data: valueListForStorage,
            type: 'line',
            backgroundColor: this.graphSettings.backgroundColorForLine,
            borderColor: this.graphSettings.graphColorList[colorCount++],
          };
          if(this.selectInterval == "2") storageGraphData.yAxisID = "y-axis-2";	//日別のみ2軸
          else storageGraphData.yAxisID = "y-axis-1";
          // 棒グラフより手前に表示させるため配列の先頭に挿入
          graphDataList.unshift(storageGraphData);
        }
      }

      if (this.selectInterval == "1") {	// 直近30分のみ
        // 合成需給平均値のグラフ情報
        // 単位期間毎の合成需給平均値リスト
        let valueListForAverage = [];

        // 単位期間ごとに行う
        for (let i = 0; i < this.graphLabel.length; i++) {
          let value = data.total_average;
          valueListForAverage.push(value);
        }

        let averageGraphData = {
          label: "平均値",
          data: valueListForAverage,
          type: 'line',
          backgroundColor: this.graphSettings.backgroundColorForLine,
          borderColor: this.graphSettings.borderColorForAverage,
          borderDash: [5, 5]
        };

        // 棒グラフより手前に表示させるため配列の先頭に挿入
        graphDataList.unshift(averageGraphData);
      }

      // 合成需給のグラフ情報
      // 単位期間毎の合成需給値リスト
      let valueListForTotal = [];

      // 単位期間ごとに行う
      for (let i = 0; i < this.graphLabel.length; i++) {
        let value = data.total_list[i].value;
        valueListForTotal.push(value);
      }

      let totalGraphData = {
        label: "合成需給",
        data: valueListForTotal,
        type: 'line',
        backgroundColor: this.graphSettings.backgroundColorForLine,
        borderColor: this.graphSettings.borderColorForTotal
      };

      // 棒グラフより手前に表示させるため配列の先頭に挿入
      graphDataList.unshift(totalGraphData);
      
      var chartData = {
        labels: this.graphLabel,
        datasets: graphDataList
      };

      if (this.chart) {
        this.chart.destroy();
      }
      
      this.chart = new Chart(
        document.getElementById("canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: this.graphOptions,
        }
      );  
    },

    /*グラフ(月別)オプション処理*/
    setGraphOptionMonth: function(){
      // ツールチップのタイトル
      let tooltipTitleTxt = "当日一日分のデータを示す\n";
      let periodStartDateAry = this.periodStartDate.split("-");
      let YYYY = periodStartDateAry[0];
      let MM = periodStartDateAry[1];
      tooltipTitleTxt = tooltipTitleTxt + YYYY + "年" + MM + "月";
      
      delete this.graphOptions.tooltips.callbacks.title;
      this.graphOptions.tooltips.callbacks.title = 
              function (tooltipItem, data) {
                const xLabel = tooltipItem[0].xLabel;
                const title = tooltipTitleTxt + (((""+xLabel).length<2)? "0"+xLabel : xLabel) + "日";
                return title;
              };

      // Y軸の最上段の単位
      // 1軸目を変更
      this.graphOptions.scales.yAxes[0].ticks.callback = 
              function (value, index,) {
                if (index === 0) {
                  return "(kWh)";
                }
                return value.toFixed(1);
              };
      
      // 2軸目を削除
      if(this.graphOptions.scales.yAxes.length > 1){
        this.graphOptions.scales.yAxes.pop();	//Y軸の要素末尾を削除。
      }
    },
    
    /*グラフ(日別)オプション処理*/
    setGraphOptionDay: function(){
      // ツールチップのタイトル
      let tooltipTitleTxt = "過去30分間のデータを示す\n当日";

      delete this.graphOptions.tooltips.callbacks.title;
      this.graphOptions.tooltips.callbacks.title = 
              function (tooltipItem, data) {
                const xLabel = tooltipItem[0].xLabel;
                const title = tooltipTitleTxt + (((""+xLabel).length<2)? "0"+xLabel : xLabel);
                return title;
              };

      // Y軸の最上段の単位
      // 1軸目を変更
      this.graphOptions.scales.yAxes[0].ticks.callback = 
              function (value, index,) {
                if (index === 0) {
                  return "(kW)";
                }
                return value.toFixed(1);
              };
              
      //2軸目を生成
      if(this.graphOptions.scales.yAxes.length < 2){
        let addyAxes = {
              id: "y-axis-2",
              type: "linear",
              position: "left",
              ticks: {
                callback: function (value, index,) {
                  if (index === 0) {
                    return "(kWh)";
                  }
                  return value.toFixed(1);
                },
              },
            };
        this.graphOptions.scales.yAxes.push(addyAxes);	//Y軸要素を末尾に追加。
      }
    },
    
    /*グラフ(直近30分)オプション処理*/
    setGraphOptionMinute: function(){
      // ツールチップのタイトル
      let tooltipTitleTxt = "過去５分間のデータを示す\n当日";

      delete this.graphOptions.tooltips.callbacks.title;
      this.graphOptions.tooltips.callbacks.title = 
              function (tooltipItem, data) {
                const xLabel = tooltipItem[0].xLabel;
                const title = tooltipTitleTxt + (((""+xLabel).length<2)? "0"+xLabel : xLabel);
                return title;
              };

      // Y軸の最上段の単位
      // 1軸目を変更
      this.graphOptions.scales.yAxes[0].ticks.callback = 
              function (value, index,) {
                if (index === 0) {
                  return "(kW)";
                }
                return value.toFixed(1);
              };
      
      // 2軸目を削除
      if(this.graphOptions.scales.yAxes.length > 1){
        this.graphOptions.scales.yAxes.pop();	//Y軸の要素末尾を削除。
      }
    },

    /*グラフ処理*/
    setGraph: async function(target){
      if(this.autoUpdateId != null){	//グラフ更新タイマー初期化
// console.log("■■■■■■setGraph：グラフ更新タイマー停止 タイマーID="+this.autoUpdateId);
        clearInterval(this.autoUpdateId);
        this.autoUpdateId = null;
      }
      
      if(this.isBeforeDestoryFlg){
// console.log("■■■■■■setGraph：終了this.isBeforeDestoryFlg="+this.isBeforeDestoryFlg);
        return;
      }
      
      if(this.selectInterval == "1" && this.autoUpdateStatus == 0){	// (直近30分グラフで自動更新OFF)以外
//console.log("■■■■■■setGraph：終了(直近30分グラフで自動更新OFF)");
        return;
      }
      
      //引数targetはハイフン区切り(例"yyyy-mm-dd")なので、サーバー送信用"yyyy/mm"に変換する
      let paramTarget = target.split("-").join("/");
      let XInterval = 5;	//直近30分用mode 1:データ間隔1分毎 5:データ間隔5分毎(2023/03/06の打ち合わせで1分毎は無くなった)
      let reqAPI="/srv/api/aggregation_recently/";	//直近30分
      let reqParam={
                    mode: XInterval
                   };

      if(this.selectInterval == "2"){	//日別
        reqAPI="/srv/api/aggregation_daily/";
        reqParam={
                  target: paramTarget,
                  mode: null
                 };

      }
      else if(this.selectInterval == "3"){	//月別
        reqAPI="/srv/api/aggregation_monthly/";
        reqParam={
                  target: paramTarget,
                  mode: null
                 };
      }

      await this.reqGraphData(target, reqAPI, reqParam);
      
      if(this.reqErrorFlg == 0){
        // データが1件も存在しない場合、「データが存在しません」を表示
        if(!((this.graphData.is_exist === undefined))) this.isExist = this.graphData.is_exist;

        let domBtnCSV = document.getElementById("iCSVDownloadBtn");
        if(this.isExist){
          domBtnCSV.className = "bt";	// CSVダウンロードボタン制御

          if(this.selectInterval == "2"){	//日別
              this.graphLabel = ["00:30","01:00","01:30","02:00","02:30","03:00","03:30","04:00","04:30","05:00","05:30","06:00","06:30","07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00","20:30","21:00","21:30","22:00","22:30","23:00","23:30","00:00"];
              this.setGraphOptionDay();
          }
          else if(this.selectInterval == "3"){	//月別
              this.graphLabel = this.getXAxisMonthdays(target);
              this.setGraphOptionMonth();
          }
          else{	//直近30分
              this.graphLabel = this.getXAxisMinutes(this.graphData.target_date);
              this.setGraphOptionMinute();
          }

// console.log("■■■■■■setGraph：グラフ表示selectInterval="+this.selectInterval);
          this.drawGraph(this.graphData, paramTarget);
        }
        else{
          domBtnCSV.className = "bt-csv-gray";	// CSVダウンロードボタン制御
          if (this.chart) {
// console.log("■■■■■■setGraph：データなしグラフ消去selectInterval="+this.selectInterval);
            this.chart.destroy();
          }
        }
      }
        if(!(this.selectInterval == "1" && this.autoUpdateStatus == 0)){	// (直近30分グラフで自動更新OFF)以外
          this.autoUpdateId = setInterval(() => {
            this.setGraph(this.periodStartDate);
          }, this.autoUpdateTime);
// console.log("■■■■■■setGraph：グラフ更新タイマー開始 タイマーID="+this.autoUpdateId);
        }
    },
    
    /*グラフデータ取得*/
    reqGraphData: async function(pTarget, pReqAPI, pReqParam){

      await this.$axios
        .post(`${pReqAPI}${Store.state.parentID}`, pReqParam, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
              console.log(data);
              this.reqErrorFlg = 1;
          } else {
              this.graphData = response.data;
              this.reqErrorFlg = 0;
          }
        })
        .catch(error => {
          this.reqErrorFlg = 1;
        });
    },
    
    /* 表示範囲切り替え処理 */
    selectPeriod: function (period) {
      //グラフ制御
      this.setGraph(this.periodStartDate);
    },
    
    /* 表示範囲の日付の左右ボタンの処理 */
    ctrlDate: function (selectBtn) {
      const date = selectBtn < 2 ? this.periodStartDate : this.periodEndDate;
      const currentDate = date ? new Date(date) : new Date(Date.now());	//JSTで生成(UTCならnew Date(Date.now()))
      const operation = selectBtn % 2 === 0 ? -1 : 1;
      if (this.periodInputType === "datetime-local") {
        currentDate.setDate(currentDate.getDate() + operation);
      } else if (this.periodInputType === "date") {
        currentDate.setDate(currentDate.getDate() + operation);
        document.getElementById("iCalWeek").textContent = "（"+this.getDateWeekTxt(currentDate.toString())+"）";
      } else {
        currentDate.setMonth(currentDate.getMonth() + operation);
      }
      if (selectBtn < 2) {
        this.periodStartDate = this.generationDateStr(currentDate);
      } else {
        this.periodEndDate = this.generationDateStr(currentDate);
      }
      this.selectPeriod("-1");
    },

    /* Date型をHTMLのinput形式に変換する処理 */
    generationDateStr: function (date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      if (this.periodInputType === "datetime-local") {
        return `${yyyy}-${mm}-${dd}T${hour}:${minute}`;
      } else if(this.periodInputType === "date") {
        return `${yyyy}-${mm}-${dd}`;
      } else {
        return `${yyyy}-${mm}`;
      }
    },
    
    /* 該当日付の曜日を返す処理 */
    getDateWeekTxt: function(strDate){
      let weekTxt = ["日", "月", "火", "水", "木", "金", "土"];
      const targetDate = new Date(strDate);
      let week = targetDate.getDay();
      return weekTxt[week];
    },
    
    /* 自動更新切替処理 */
    toggleAutoUpdate: function () {
      const autoUpdateValue = document.getElementById("auto-update-btn").className;
      if (autoUpdateValue === "bt") {
        document.getElementById("auto-update-btn").className = "bt-enable";
        document.getElementById("auto-update-tooltip-description").innerHTML = "現在、自動更新有効です。";
        this.autoUpdateStatus = 1;

        this.setGraph(this.periodStartDate);
//console.log("■■■■■■toggleAutoUpdate:グラフsetGraph呼び出し ID=" + this.autoUpdateId +"[" + typeof(this.autoUpdateId) +"]");
      }
      else if (autoUpdateValue === "bt-enable") {
        document.getElementById("auto-update-btn").className = "bt";
        document.getElementById("auto-update-tooltip-description").innerHTML = "現在、自動更新無効です。";
        this.autoUpdateStatus = 0;
        
//console.log("■■■■■■toggleAutoUpdate：グラフ更新タイマー停止指示 タイマーID="+this.autoUpdateId);
      }
    },

    // Download CSV
    onExportCSV: function() {
      if(!this.isExist) return;
      
      let csvData = null;
      csvData = this.getCsvData();
      this.exportData(csvData.body, csvData.fileNamePrefix, csvData.header);
    },
    
    // CSVデータ生成
    getCsvData: function(){
      
      const graphData = this.graphData;
      const demandList = graphData.demand_list_by_account;		//消費電力
      const generationList = graphData.generation_list_by_account;		//発電電力
      const storageList = graphData.storage_list_by_account;	//残蓄電量
      const totalList = graphData.total_list;					//合成需給
      
      let totalForecastList = null;	//予測値
      let totalAverage = null;		//平均値
      let demandDataUnitTxt="電力(kW)";	//電力の単位
      let unitTxt="(kW)";	//電力の単位
      
      if(this.selectInterval == "1"){	//直近30分グラフ時
        totalForecastList = graphData.total_forecast_list;	//予測値
        totalAverage = graphData.total_average;				//平均値
        if(totalAverage==null) totalAverage="";	//棒グラフが1本のみの表示の場合は、ヘッダーを出力する為に""を代入する。
      }

      if(this.selectInterval == "3"){	//月別グラフ時
        demandDataUnitTxt="電力量(kWh)";
        unitTxt="(kWh)";
      }
      
      let header = [];
      header.push('日時');
      for(let companyCnt=0;companyCnt<demandList.length;companyCnt++){
        header.push(demandList[companyCnt].company_name+"_消費"+demandDataUnitTxt);	//※単位に注意
      }
      if(generationList != null){
        for(let companyCnt=0;companyCnt<generationList.length;companyCnt++){
          header.push(generationList[companyCnt].company_name+"_発電"+demandDataUnitTxt);
        }
      }
      if(storageList != null){
        for(let companyCnt=0;companyCnt<storageList.length;companyCnt++){
          header.push(storageList[companyCnt].company_name+"_残蓄電量(kWh)");
        }
      }
      header.push("合成需給"+unitTxt);
        
      if(totalForecastList != null){	//直近30分グラフ時
        header.push("合成需給予測値"+unitTxt);	//予測値
      }
      if(totalAverage != null){	//直近30分グラフ時
        header.push("合成需給平均値"+unitTxt);	//平均値(各Row同一値)
      }
        
      let body = [];
      let bodyRow = [];

      const valuCntLimit = demandList[0].data_list.length	//data_listの要素数は同じなのでdemand_list_by_accountのdata_listを基準にする。

      for(let valueCnt=0;valueCnt<valuCntLimit;valueCnt++){
        bodyRow = [];
        bodyRow.push(demandList[0].data_list[valueCnt].date.split("/").join("-"));	//日時

        for(let companyCnt=0;companyCnt<demandList.length;companyCnt++){
          bodyRow.push(((demandList[companyCnt].data_list[valueCnt].value != null)? demandList[companyCnt].data_list[valueCnt].value : ""));
        }
        if(generationList != null){
          for(let companyCnt=0;companyCnt<generationList.length;companyCnt++){
            bodyRow.push(((generationList[companyCnt].data_list[valueCnt].value != null)? generationList[companyCnt].data_list[valueCnt].value : ""));
          }
        }
        if(storageList != null){
          for(let companyCnt=0;companyCnt<storageList.length;companyCnt++){
            bodyRow.push(((storageList[companyCnt].data_list[valueCnt].value != null)? storageList[companyCnt].data_list[valueCnt].value : ""));
          }
        }
        
        bodyRow.push(totalList[valueCnt].value);			//合成需給
        
        if(totalForecastList != null){	//直近30分グラフ時
          bodyRow.push(totalForecastList[valueCnt].value);	//予測値
        }
        if(totalAverage != null){	//直近30分グラフ時
          bodyRow.push(totalAverage);							//平均値(各Row同一値)
        }
        
        body.push(bodyRow);
      }
      
      let fileNamePrefix = "電力需給状況_";
      
      if(this.selectInterval == "2"){	//日別グラフ時
        fileNamePrefix = fileNamePrefix + "日別_" + `${Store.state.parentID}` + "_" + demandList[0].data_list[0].date.split(" ")[0].split("/").join("");
      }
      else if (this.selectInterval == "3"){	//月別グラフ時
        let dataListDateAry = demandList[0].data_list[0].date.split(" ")[0].split("/");
        let fileNamePrefixYYYY = dataListDateAry[0];
        let fileNamePrefixMM = dataListDateAry[1];
        fileNamePrefix = fileNamePrefix + "月別_" + `${Store.state.parentID}` + "_" + fileNamePrefixYYYY + fileNamePrefixMM;
      }
      else{	//直近30分グラフ時
        fileNamePrefix = fileNamePrefix + "直近30分_" + `${Store.state.parentID}` + "_" + demandList[0].data_list[0].date.split(" ")[0].split("/").join("");
        let fileNamePrefixStartTime = demandList[0].data_list[0].date.split(" ")[1].split(":").join("");
        let fileNamePrefixEndTime = demandList[0].data_list.slice(-1)[0].date.split(" ")[1].split(":").join("");
        fileNamePrefix = fileNamePrefix + "_" + fileNamePrefixStartTime + "-" + fileNamePrefixEndTime;
      }
      
      let rt = [];
      rt.fileNamePrefix = fileNamePrefix;
      rt.header = header;
      rt.body = body;

      return rt;
    },
    
    exportData: function(resp, prefixFilename, header) {
      if (resp) {
        let data = resp; let filename = ''
        // yyyy-mm-dd_hh-mm-ss
        const fileType = '.csv'
        filename = prefixFilename + fileType || 'export.csv'
        let encodingType = 'data:text/csv;charset=utf-8,%EF%BB%BF'
        let csvContent = ''
        // add header
        let row = Object.keys(header).map((k) => header[k]).join(',')
        csvContent = row.replace(/(?:\r\n|\r|\n)/g, ' ') + '\r\n'
        // content data
        for(let i =0; i < data.length; i++) {
          csvContent += data[i]
          if (i < data.length -1) {
            csvContent += '\r\n'
          }
        }

        let encodedUri = encodeURI(csvContent)
        let blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv; charset=utf-8' })

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.setAttribute('class', 'export-csv-file')
          link.setAttribute('href', encodingType + encodedUri)
          link.setAttribute('download', filename)
          link.setAttribute('style', 'visibility:hidden')
          document.body.appendChild(link) // Required for FF
          link.click() // This will download the data file named "CSVダウンロード_YYYY-MM-DD".
          window.URL.revokeObjectURL(data)
        }
      }
    }
  }
};
</script>
<style scoped>
/* グラフ画面全体 */
.multi-circuit-ef--inner {
  width: 92vw;
  margin: 0 auto;
  margin-bottom: 20px;
  position: relative;
}

.graph-header-caption {
  color: #FFFFFF;
  font-size: 18px;
  line-height: 45px;
}

/* 自動更新ボタン */
.graph-header-button .bt-enable {
  display: inline-block;
  background-color: #e2211a;
  border-radius: 20px;
  padding: 4px 14px;
  color: #ffffff;
}

.graph-header-button .bt-enable:hover {
  opacity: 0.8;
}

/* 自動更新ボタンのツールチップ */
.auto-update-tooltip {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.auto-update-tooltip-description {
  display: none;
  position: absolute;
  padding: 6px;
  font-size: 12px;
  line-height: 1.6em;
  color: #fff;
  border-radius: 5px;
  background: #000;
  width: 140px;
  opacity: 0.75;
  white-space: nowrap;
}

.auto-update-tooltip-description:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  border: 7px solid transparent;
  border-top: 7px solid #000;
  margin-left: -5px;
}

.auto-update-tooltip:hover .auto-update-tooltip-description {
  display: inline-block;
  top: -40px;
  left: -35px;
}
/*CSVダウンロードボタン*/
.graph-header-button .bt-csv-gray {
  display: inline-block;
  background-color: #91a1af;
  border-radius: 20px;
  padding: 4px 14px;
  color: #fff;
  font-size: 14px;
}
.graph-header-button .bt-csv-gray:hover {
  opacity: 1.0;
}

/* 表示範囲 */
.display-period {
  padding: 5px 5px 10px 105px;
  margin: 6px 0;
  display: flex;
  align-items: center;
}

.display-period p {
  margin: 0 5px;
}

.select-date {
  border: #000;
}

.display-period .select-date {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.display-period .select-date input {
  border-top: 1px solid #5ca1d6;
  border-bottom: 1px solid #5ca1d6;
}

/* 表示範囲 カレンダー */
.bt-date {
  background-color: #5ca1d6;
  border: 1px solid #5ca1d6;
  color: #fff;
  padding: 1px 1px;
}

.bt-date:hover {
  background-color: #005cc0;
}

.margin0auto {
  margin: 0 auto;
}

.rc-week {
  margin: 0px 0px 0px 0px;
}
.text-align-center {
  text-align: center;
}
</style>
